// extracted by mini-css-extract-plugin
export var accordion = "_bn-0";
export var chevron = "_bn-3";
export var closed = "_bn-2";
export var content = "_bn-4";
export var open = "_bn-1";
export var rotate = "_bn-5";